var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container contacts-container"},[_c('contacts-table',{key:_vm.$route.fullPath}),_c('floating-action-button',{attrs:{"show":_vm.isLogged,"onclick":_vm.navigateToAdd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }